
import { StrictMode } from "react";

import { createRoot } from "react-dom/client";
import App from "./App";
import './index.css'
const c=document.getElementById('root');

const root=createRoot(c);
root.render(
    <StrictMode>
        <App/>
    </StrictMode>
)
